var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/navigation/Partner.tsx",
  _this = this;
import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';
var COPY = defineMessages({
  PARTNER: {
    id: 'Partner.partner',
    defaultMessage: 'Partner',
    description: '[Type: Label][Vis.: low] - Partner link in main navigation'
  }
});
var Partner = function Partner() {
  return /*#__PURE__*/React.createElement(MainNavButton, {
    href: "https://www.surveymonkey.com/mp/partner-program/",
    label: t(COPY.PARTNER),
    navItem: "partner",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 3
    }
  });
};
export default Partner;
export { Partner };
//# sourceMappingURL=Partner.js.map